import type { Pickup } from '@/modules/pickup/domain/Pickup';
import type { PickupRepository } from '@/modules/pickup/domain/PickupRepository';
import { sessionStorageRepository } from '@/modules/shared/infrastructure/SessionStorage';

const sessionStoragePickup = sessionStorageRepository<Pickup, number>(
  'pickups'
);

const getAll = (): Promise<Pickup[]> =>
  new Promise((resolve) => {
    setTimeout(async () => {
      resolve(await sessionStoragePickup.getAll());
    }, 1000);
  });

const save = (pickup: Pickup | Omit<Pickup, 'id'>): Promise<Pickup> =>
  new Promise((resolve) => {
    setTimeout(async () => {
      if ('id' in pickup) {
        resolve(await sessionStoragePickup.update(pickup));
      } else {
        resolve(await sessionStoragePickup.save(pickup));
      }
    }, 1000);
  });

const getByDeliveryId = (id: number): Promise<Pickup[]> =>
  new Promise((resolve) => {
    setTimeout(async () => {
      const pickups = await sessionStoragePickup.getAll();
      resolve(pickups.filter((pickup) => pickup.deliveryId === id) as Pickup[]);
    }, 1000);
  });

export const pickupSessionStorageRepository: PickupRepository = {
  getAll,
  save,
  getByDeliveryId
};
